import { Link } from "react-router-dom";
import { FiSearch } from "react-icons/fi";

function SearchCard() {
  return (
    <Link to="/discover" style={cardStyle}>
      <div style={iconStyle}>
        <FiSearch />
      </div>

      <div style={contentStyle}>
        <h3 style={titleStyle}>Search MyBuildID</h3>

        <p style={subtitleStyle}>
          Find builds, users, vehicles, parts and brands.
        </p>
      </div>

      <span style={arrowStyle}>→</span>
    </Link>
  );
}

const cardStyle = {
  display: "flex",
  alignItems: "center",
  gap: "16px",
  backgroundColor: "#181818",
  border: "1px solid #2a2a2a",
  borderRadius: "18px",
  padding: "18px",
  textDecoration: "none",
  color: "white",
  transition: "0.2s ease",
  maxWidth: "620px",
margin: "0 auto",
};

const iconStyle = {
  width: "50px",
  height: "50px",
  borderRadius: "999px",
  backgroundColor: "#e10600",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "22px",
  flexShrink: 0,
};

const contentStyle = {
  flex: 1,
};

const titleStyle = {
  margin: 0,
  fontSize: "18px",
  fontWeight: "700",
};

const subtitleStyle = {
  margin: "4px 0 0",
  color: "#9a9a9a",
  fontSize: "14px",
  lineHeight: "1.4",
};

const arrowStyle = {
  fontSize: "22px",
  color: "#666",
};

export default SearchCard;